import { diContainer, serviceNames } from '../../service-setup/diContainer';
import { ConfigRepository } from '../repositories/ConfigRepository';

export class ProductUgcServiceStartedUseCase {
    private configRepository: ConfigRepository;
    private configs: string[];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(configs: any) {
        this.configRepository = diContainer.get(serviceNames.configRepository);
        this.configs = configs;
    }

    public execute = async () => {
        await this.configRepository.getConfigs(this.configs);
    };
}
